<template>
        <div class="bg-secondary p-1">
            <form class="form-inline" @submit.prevent="saveZums">
                <label class="mr-sm-2" for="operation">ZUM</label>

                <div class="col-md-5">
                    <multiselect v-model="selected" id="searchMaterial" label="label" track-by="code" placeholder="vyhledat materiál" open-direction="bottom" :options="materials" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getMaterials" @select="selectMaterial" selectLabel="" :data-testid="'visit-zum-search-' + actionId">
                        <template slot="option" scope="props">
                            <div class="option__desc"><span class="option__title">{{ props.option.label }}</span></div>
                        </template>
                    </multiselect>
                </div>

                <!--<i title="interní výkon" v-if="zum.internal" @click="changeInternal" class="fa fa-hand-spock-o fa-2x text-danger" aria-hidden="true"></i>
                <i title="běžný výkon" v-else="" @click="changeInternal" class="fa fa-hand-paper-o fa-2x text-light fa-flip-horizontal" aria-hidden="true"></i>-->
                <label for="amount" class="ml-sm-2 mr-sm-2">Množství</label>
                <input v-model="zum.amount" type="number" step="0.01" min="0" max="999" class="form-control mr-sm-2 form-control-sm col-sm-1" aria-describedby="operationHelp" id="amount" :data-testid="'visit-zum-amount-' + actionId">
                <button v-if="!zumPending" type="submit" id="addZumsButton" class="btn btn-sm btn-success" :data-testid="'visit-zum-add-' + actionId">Přidat</button>
                <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </form>
        </div>
</template>

<script>
  // import { mapState, mapZumss } from 'vuex'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        selected: null,
        // zum (post)
        zum: {
          material: '',
          amount: 1
        },
        zumPending: false,
        zumDone: false,
        zumError: false,
        // Materials
        materials: [],
        materialsError: false,
        materialsPending: false
      }
    },
    props: ['actionId', 'operation'],
    mixins: [apiMixin],
    methods: {
      selectMaterial (val) {
        this.zum.material = val.code
        document.getElementById('addZumsButton').focus()
      },
      saveZums () {
        this.postZum(this.actionId, this.zum)
      },
      /* zumAdded () {
        this.$emit('update', this.actionId)
      }, */
      selectOperation (val) {
        this.zum.operation = val.code
        document.getElementById('addZumsButton').focus()
      },
      changeInternal () {
        this.zum.internal = !this.zum.internal
      }
    },
    beforeMount () {
    },
    watch: {
      zumDone (val) {
        if (val === true) {
          this.zum = {
            material: '',
            amount: 1
          }
          this.$emit('update')
          this.zumDone = false
          // this.operations = []
          this.selected = null
          this.materials = []
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }
</style>

<style>
    span.multiselect__option {
        min-height: 10px !important;
        padding: 6px !important;
    }

    span.option__title.available {
        color: #000;
        font-weight: bolder;
    }

    span.option__title.unavailable {
        color: #666;
    }


</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AddZum.vue?384d198a